export default {
  outList: [
    {
      light_point_4:[
        {
          title: '“磐石”车身',
          type: 'image',
          video: '',
          image: 'lightPoint/2/2.jpg',
          text: ''
        },
        {
          title: '守护者电池安全系统',
          type: 'image',
          video: '',
          image: 'lightPoint/2/3.jpg',
          text: '电池包防水IP68级'
        },
        {
          title: '全时域智电管理',
          type: 'image',
          video: '',
          image: 'lightPoint/3/4.jpg',
          text: 'CLTC纯电续航120km',
          text2:'WLTC综合续航1400+km'
        }
      ],
      light_point_1:[
        {
          title: '全系标配远端气囊',
          type: 'image',
          video: '',
          image: 'lightPoint/2/1.jpg',
          text: ''
        },

        {
          title: '300万像素超高清',
          type: 'image',
          video: '',
          image: 'lightPoint/2/4.jpg',
          text: '540全景影像'
        }
      ],
      light_point_3:[
        {
          title: '既有澎湃动力，亦可从容远行',
          type: 'image',
          video: '',
          image: 'lightPoint/3/1.jpg',
          text: '才是新豪华产品',
        },
        {
          title: '鲲鹏超能混动C-DM',
          type: 'image',
          video: '',
          image: 'lightPoint/3/2.jpg',
          text: '百公里油耗5.2L（WLTC）',
        },
        {
          title: '超级电混DHT',
          type: 'image',
          video: '',
          image: 'lightPoint/3/3.jpg',
          text: '电机最高效率97.5%',
        },

      ],
      light_point_2:[
        {
          title: '20吋穹顶轮毂',
          type: 'image',
          video: '',
          image: 'lightPoint/4/3.jpg',
          text: ''
        },
        {
          title: 'CDC“磁悬浮”悬架',
          type: 'image',
          video: '',
          image: 'lightPoint/4/8.jpg',
          text: '毫秒级响应,无极变阻'
        }
      ]
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '一键舒躺女王副驾',
          type: 'image',
          video: '',
          image: 'lightPoint/1/7.jpg',
          text: ''
        },
        {
          title: '前排10点按摩+靠背/坐垫3档加热及通风',
          type: 'image',
          video: '',
          image: 'lightPoint/1/8.jpg',
          text: ''
        },
        {
          title: '3Dmesh麂皮绒包裹',
          type: 'image',
          video: '',
          image: 'lightPoint/4/6.jpg',
          text: ''
        },
      ],
      light_point_2:[
        {
          title: '15.6吋2.5k高清大屏+10.25吋仪表',
          type: 'image',
          video: '',
          image: 'lightPoint/5/2.jpg',
          text: ''
        },
        {
          title: '8155高算力芯片',
          type: 'image',
          video: '',
          image: 'lightPoint/5/3.jpg',
          text: ''
        },
        {
          title: 'AI智慧交互',
          type: 'image',
          video: '',
          image: 'lightPoint/5/6.jpg',
          text: ''
        },
      ],
      light_point_3:[
        {
          title: '静谧健康座舱',
          type: 'image',
          video: '',
          image: 'lightPoint/4/2.jpg',
          text: '环保材质+严格工艺控制,实现气味3.0'
        },
      ],
      light_point_4:[
        {
          title: 'SONY殿堂级14扬环绕音响',
          type: 'image',
          video: '',
          image: 'lightPoint/4/4.jpg',
          text: ''
        },
      ],
      light_point_5:[
        {
          title: 'TOM雅致木纹饰板',
          type: 'image',
          video: '',
          image: 'lightPoint/4/7.jpg',
          text: ''
        },
      ],
      light_point_6:[
        {
          title: '50w手机无线快充',
          type: 'image',
          video: '',
          image: 'lightPoint/5/4.jpg',
          text: ''
        },
      ],
      light_point_7:[
        {
          title: '舒心二排',
          type: 'image',
          video: '',
          image: 'lightPoint/1/93.jpg',
          text: '二排空调独立控制'
        }
      ]
    }
  ],
  tab1:[
    {
      title: '5+2座灵活空间',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '越级豪华大空间'
    },
    {
      title: '露营大床',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: ''
    },
    {
      title: '冲浪模式',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '',
    },
    {
      title: '懒人沙发',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: ''
    },
    {
      title: '亲子骑行',
      type: 'image',
      video: '',
      image: 'lightPoint/1/5.jpg',
      text: ''
    },
    {
      title: 'SPA级舒享座椅',
      type: 'image',
      video: '',
      image: 'lightPoint/1/6.jpg',
      text: ''
    },
    {
      title: '一键舒躺女王副驾',
      type: 'image',
      video: '',
      image: 'lightPoint/1/7.jpg',
      text: ''
    },
    {
      title: '前排10点按摩+靠背/坐垫3档加热及通风',
      type: 'image',
      video: '',
      image: 'lightPoint/1/8.jpg',
      text: ''
    },
    {
      title: '舒心二排',
      type: 'image',
      video: '',
      image: 'lightPoint/1/91.jpg',
      text: '副驾老板键'
    },
    {
      title: '舒心二排',
      type: 'image',
      video: '',
      image: 'lightPoint/1/92.jpg',
      text: 'B柱出风口'
    },
    {
      title: '舒心二排',
      type: 'image',
      video: '',
      image: 'lightPoint/1/93.jpg',
      text: '二排空调独立控制'
    }
  ],
  tab2: [
    {
      title: '全系标配远端气囊',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: ''
    },
    {
      title: '“磐石”车身',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: ''
    },
    {
      title: '守护者电池安全系统',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: '电池包防水IP68级'
    },
    {
      title: '300万像素超高清',
      type: 'image',
      video: '',
      image: 'lightPoint/2/4.jpg',
      text: '540全景影像'
    }
  ],
  tab3: [
    {
      title: '既有澎湃动力，亦可从容远行',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '才是新豪华产品',
    },
    {
      title: '鲲鹏超能混动C-DM',
      type: 'image',
      video: '',
      image: 'lightPoint/3/2.jpg',
      text: '百公里油耗5.2L（WLTC）',
    },
    {
      title: '超级电混DHT',
      type: 'image',
      video: '',
      image: 'lightPoint/3/3.jpg',
      text: '电机最高效率97.5%',
    },
    {
      title: '全时域智电管理',
      type: 'image',
      video: '',
      image: 'lightPoint/3/4.jpg',
      text: 'CLTC纯电续航120km',
      text2:'WLTC综合续航1400+km'
    }
  ],
  tab4: [
    {
      title: '生而全球才是新豪华',
      type: 'image',
      video: '',
      image: 'lightPoint/4/1.jpg',
      text: '',
    },
    {
      title: '静谧健康座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/4/2.jpg',
      text: '环保材质+严格工艺控制,实现气味3.0'
    },
    {
      title: '20吋穹顶轮毂',
      type: 'image',
      video: '',
      image: 'lightPoint/4/3.jpg',
      text: ''
    },
    {
      title: 'SONY殿堂级14扬环绕音响',
      type: 'image',
      video: '',
      image: 'lightPoint/4/4.jpg',
      text: ''
    },
    {
      title: '私享头枕音响',
      type: 'image',
      video: '',
      image: 'lightPoint/4/5.jpg',
      text: '',
    },
    {
      title: '3Dmesh麂皮绒包裹',
      type: 'image',
      video: '',
      image: 'lightPoint/4/6.jpg',
      text: ''
    },
    {
      title: 'TOM雅致木纹饰板',
      type: 'image',
      video: '',
      image: 'lightPoint/4/7.jpg',
      text: ''
    },
    {
      title: 'CDC“磁悬浮”悬架',
      type: 'image',
      video: '',
      image: 'lightPoint/4/8.jpg',
      text: '毫秒级响应,无极变阻'
    }
  ],
  tab5: [
    {
      title: '类人AI才是新豪华',
      type: 'image',
      video: '',
      image: 'lightPoint/5/1.jpg',
      text: '',
    },
    {
      title: '15.6吋2.5k高清大屏+10.25吋仪表',
      type: 'image',
      video: '',
      image: 'lightPoint/5/2.jpg',
      text: ''
    },
    {
      title: '8155高算力芯片',
      type: 'image',
      video: '',
      image: 'lightPoint/5/3.jpg',
      text: ''
    },
    {
      title: '50w手机无线快充',
      type: 'image',
      video: '',
      image: 'lightPoint/5/4.jpg',
      text: ''
    },
    {
      title: '高清HUD抬头显示',
      type: 'image',
      video: '',
      image: 'lightPoint/5/5.jpg',
      text: '识别人脸调整高度',
    },
    {
      title: 'AI智慧交互',
      type: 'image',
      video: '',
      image: 'lightPoint/5/6.jpg',
      text: ''
    },
    {
      title: 'LCA并线辅助',
      type: 'image',
      video: '',
      image: 'lightPoint/5/7.jpg',
      text: ''
    },
    {
      title: 'AEB自动紧急制动',
      type: 'image',
      video: '',
      image: 'lightPoint/5/8.jpg',
      text: ''
    }
  ]
}
